import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { ErrorBoundary } from "error/ErrorBoundary";
import { useGetMeQuery } from "graphql/generated/schema-types";
import { Location } from "history";
import { Redirect, Route, RouteProps } from "react-router-dom";

function SetPrevLocation({ location }: { location: Location }) {
  sessionStorage.setItem("prevLocation", location.pathname + location.search);
  return null;
}

type RequireAuthProps = RouteProps & {
  redirectTo?: string;
  children: Readonly<React.ReactNode>;
};

export default function RequireAuth({
  redirectTo = "/login",
  children,
  ...routeProps
}: RequireAuthProps) {
  return (
    <Route
      {...routeProps}
      render={({ location }) => (
        <>
          <AuthenticatedTemplate>
            <ErrorBoundary>{children}</ErrorBoundary>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <SetPrevLocation location={location} />
            <Redirect to={redirectTo} />
          </UnauthenticatedTemplate>
        </>
      )}
    />
  );
}

export function RequireAdmin({
  children,
}: {
  children: Readonly<React.ReactNode>;
}): JSX.Element {
  const { data } = useGetMeQuery({
    fetchPolicy: "cache-only",
  });

  if (!data?.me?.isAdmin)
    return <Redirect to={{ pathname: "/unauthorized" }} />;
  return <>{children}</>;
}
